import styled from 'styled-components';

interface RowProps {
    reverse?: boolean;
}

export const SectionRow = styled.div<RowProps>`
    display: flex;
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
    align-items: center;
    padding: 44px 0;

    @media (max-width: 990px) {
        flex-direction: column;
        padding: 25px 0;
    }
`

export const SectionContent = styled.div`
    padding: 0 44px;

    h2 {
        margin-bottom: 24px;
        font-size:30px;
        font-weight:700;
        color:#FCC068;
    }

    p {
        font-size:20px;
        color: #000;
    }

    @media (max-width: 990px) {
        padding-left: 0;
        padding-right: 0;

        h2{
            font-size:22px;
        }

        p{
            font-size:16px;
        }
    }
`

export const SectionImg = styled.div`
    flex-shrink: 0;
    max-width: 45%;
    
    img {
        max-width: 100%;
    }

    @media (max-width: 990px) {
        max-width: 100%;
    }
`

export const HomeSection = styled.div`
    background-color: #fff;
    text-align: center;
    padding-top: 64px;
    padding-bottom: 32px;
`

export const PartnerRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0;
    justify-content: center;
    align-items: center;

    img {
        width: 124px;
        margin: 24px 20px;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        opacity: .6;
    }
`

export const HomepageTopSectionMain = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    padding-top: 120px;

    h1 {
        font-size: 48px;
        font-weight: 600;
        margin-bottom: 10px;
        color: #3c3737;
    }

    p {
        font-size: 20px;
        color: #666;
        color: #fff;
    }
`

export const HomepageTopSectionImg = styled.div`
    display: flex;
    flex: 1;
    justify-content: end;

    img {
        width: 90%;
        max-width: 640px;
    }

    @media (max-width: 767px) {
        display: none;
    }
`
